import { connect } from 'react-redux';
import { withRouter } from 'react-router';

import LoginPage from './LoginPage';

import {
    clearAuthNotification as clearAuthNotificationAction,
    trackSocialProviderClick as trackSocialProviderClickAction,
    redirectToSignUp as redirectToSignUpAction,
} from '../../actions/auth';
import { onSkipSocialLinks } from '../../actions/mocks';
import { socialLogInUser as socialLogInUserAction } from '../../actions/social';

const _mapStateToProps = ({ authentication }) => ({
    socialSSOSettings: authentication.socialSSOSettings,
    usesNewStyles: authentication.featureFlags.launchAuthenticationRefactor,
    skipSocialCalls: authentication.skipSocialCalls,
});
const _mapDispatchToProps = {
    clearAuthNotification: clearAuthNotificationAction,
    onSkipSocialLinks,
    onSocialProviderClick: trackSocialProviderClickAction,
    onSocialLogInUser: socialLogInUserAction,
    handleSignUpClick: redirectToSignUpAction,
};

export default withRouter(
    connect(_mapStateToProps, _mapDispatchToProps)(LoginPage),
);
